// extracted by mini-css-extract-plugin
export var pillWrapper = "_n7-0";
export var showOverflow = "_n7-1";